export const isNumber = (value: unknown): boolean => {
    return typeof value === "number" && !Number.isNaN(value);
};

export const isString = (value: unknown): boolean => {
    return typeof value === "string";
};

export const isStringNotEmpty = (value: unknown): boolean => {
    return isString(value) && (value as string).replace(/\s/g, "") !== "";
};

export const isUndefinedString = (value: unknown): boolean => {
    return ["undefined", "NaN"].includes(`${value}`);
};

export const isDefined = (value: unknown): boolean => {
    return (
        value !== null &&
        typeof value !== "undefined" &&
        !isUndefinedString(value)
    );
};
